export const REFRESH_REPORTS_LIST = 'REFRESH_REPORTS_LIST';
export const CHANGE_SUC_SHOW = 'CHANGE_SUC_SHOW';

export const refreshReportList = reportsData => ({
  type: REFRESH_REPORTS_LIST,
  reportsData
});
export const changeSucShow = () => ({
  type: CHANGE_SUC_SHOW
});


// WEBPACK FOOTER //
// ./src/actions/reportList.js